import { OsmAPIList } from '@/api'

const api = new OsmAPIList();

export default {
  getProductList({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.getProductList(params, (json) => {
        switch (json.status) {
          case 200:
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  editProduct({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.editProduct(params, (json) => {
          switch (json.status) {
            case 200:
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }
        },
        (err) => {
          reject(err);
        })
    })
  },

  createProduct({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.createProduct(params, (json) => {
        switch (json.status) {
          case 200:
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  deleteProduct({ state }, ID) {
    return new Promise((resolve, reject) => {
      api.deleteProduct(ID, (json) => {
        switch (json.status) {
          case 200:
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  getProductDetail({ state }, ID) {
    return new Promise((resolve, reject) => {
      api.getProductDetail(ID, (json) => {
        switch (json.status) {
          case 200:
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  createCommissionRate({ state }, params) {
    return new Promise((resolve, reject) => {
      api.createCommissionRate(params, (json) => {
        switch (json.status) {
          case 200:
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  editCommissionRate({ state }, params) {
    return new Promise((resolve, reject) => {
      api.editCommissionRate(params, (json) => {
        switch (json.status) {
          case 200:
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/Osm/Product/store/actions.js